import {forwardRef} from 'react';

import MuiAccordion from '@mui/material/Accordion';

const AccordionComponent = (props, ref): JSX.Element => {
  return <MuiAccordion {...props} ref={ref} />;
};

export const Accordion = forwardRef(AccordionComponent);
